import { render, staticRenderFns } from "./logreg.vue?vue&type=template&id=15517184&scoped=true&"
import script from "./logreg.vue?vue&type=script&lang=js&"
export * from "./logreg.vue?vue&type=script&lang=js&"
import style0 from "./logreg.vue?vue&type=style&index=0&id=15517184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15517184",
  null
  
)

export default component.exports